import { widgetAction, userConstants } from '../constants';
import myFetchWithId from '../helpers/myFetch';

const templateApi = '/v5/lowi/profile/st';

export function fetchTemplateList() {
  const normalFetch = myFetchWithId('', true, true);
  return dispatch => {
    dispatch(requestTemplateList())
    return normalFetch(`${templateApi}/gets`)
      .then(json => { dispatch(receiveTemplateList(json))})
  }
}
function requestTemplateList() {
  return {
    type: userConstants.TEMPLATE_LIST_REQUEST,
  }
}
function receiveTemplateList(json) {
  return {
    type: userConstants.TEMPLATE_LIST_RECEIVE,
    templateList: json.response_status === "SUCCESS" && json.response_data ? json.response_data : [],
    receivedAt: Date.now()
  }
}

export function loadUserTemplate(id) {
  const normalFetch = myFetchWithId('', true, true);
  return dispatch => {
    dispatch(requestUserTemplate())
    return normalFetch(`${templateApi}/get`, {id: id})
      .then(json => { dispatch(receiveUserTemplate(json))})
  }
}
function requestUserTemplate() {
  return {
    type: userConstants.USER_TEMPLATE_REQUEST,
  }
}
function receiveUserTemplate(json) {
  const template = json.response_data[0] && json.response_data[0].widgets.map(t => {
    const decodeJson = decodeURIComponent(t.condition_str);
    const parseJson = JSON.parse(decodeJson);
    return parseJson;
  })
  return {
    type: userConstants.USER_TEMPLATE_RECEIVE,
    usertemplate: template ? template : [],
    receivedAt: Date.now()
  }
}

export function initStateSet(){
  return{
    type:widgetAction.INITSET,
    receivedAt:Date.now()
  }
}

export function tempDealLogOut(){
  return{
    type:widgetAction.OUT,
    receivedAt:Date.now()
  }
}

export function addNewWidget(widgetType) {
  var timestamp = (new Date()).getTime();
  var widgetId = 'widget' + timestamp;
  switch (widgetType) {
    // 概念矩陣
    case 'f95bd230-b3c0-41fd-aaf4-4738faa75ac2':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
        [{
          "type": 'f95bd230-b3c0-41fd-aaf4-4738faa75ac2',
          "uid": widgetId,
          "layout": {
            "i": widgetId,
            "x": 0,
            "y": 0,
            "w": 4,
            "h": 5
          },
          "uiState": {
            "title": "概念探尋",
            "controller": [],
            "chartType": "treemap",
            "dashboard": false,
            "mapColor": ['#92BEEB', '#FDC59A', '#F3E9D2', 'rgb(255, 180, 175)', '#C6DABF', '#F3E9D2', '#1A936F', '#ffea96'],
            "colorForm": '預設'
          }
        }]
      };
      // 概念拓墣
      case '8e438c64-a0aa-4091-93ed-9eadd659ff7b':
        return {
          type: widgetAction.ADD,
          receivedAt: Date.now(),
          newWidget:
          [{
            "type": '8e438c64-a0aa-4091-93ed-9eadd659ff7b',
            "uid": widgetId,
            "layout": {
              "i": widgetId,
              "x": 0,
              "y": 0,
              "w": 4,
              "h": 5
            },
            "uiState": {
              "title": "概念拓墣圖",
              "controller": [],
              "dashboard": false,
              "colorForm": '預設'
            }
          }]
        };
    // 搜尋結果列表
    case '355a4d6f-12a8-49e8-af27-a40b94602088':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
        [{
          "type": '355a4d6f-12a8-49e8-af27-a40b94602088',
          "uid": widgetId,
          "layout": {
            "i": widgetId,
            "x": 0,
            "y": 0,
            "w": 4,
            "h": 5
          },
          "uiState": {
            "title": "搜尋結果列表",
            "controller": [],
            "chartType": null,
            "dashboard": false
          }
        }]
      };
    // 熱門議題
    case '34712cc4-39cf-4cc4-bb13-5fe93c1bd5f5':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
        [{
          "type": '34712cc4-39cf-4cc4-bb13-5fe93c1bd5f5',
          "uid": widgetId,
          "layout": {
            "i": widgetId,
            "x": 0,
            "y": 0,
            "w": 4,
            "h": 5
          },
          "uiState": {
            "title": "熱門議題",
            "controller": [],
            "chartType": null,
            "dashboard": false
          }
        }]
      };

    // 潛在議題
    case '46c810f0-e96d-4f05-b84c-c177987d98ec':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
          [
            {
              "type": '46c810f0-e96d-4f05-b84c-c177987d98ec',
              "uid": widgetId,
              "layout": {
                "i": widgetId,
                "x": 0,
                "y": 0,
                "w": 4,
                "h": 5
              },
              "uiState": {
                "title": "潛在議題",
                "controller": [],
                "chartType": null,
                "dashboard": false
              }
            }]
      };

    // 情緒聲量
    case '9f80cf4c-9467-49cf-9226-507ecee12cb6':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
          [{
              "type": '9f80cf4c-9467-49cf-9226-507ecee12cb6',
              "uid": widgetId,
              "layout": {
                "i": widgetId,
                "x": 0,
                "y": 0,
                "w": 4,
                "h": 5
              },
              "uiState": {
                "title": "情緒聲量分析",
                "controller": [],
                "chartType": "line",
                "posttype": "",
                "voice": 1,
                "dashboard": false
              }
            }]
      };
      case '1a3384ed-17f9-43d0-a3a6-350f2f92c292':
        return {
          type: widgetAction.ADD,
          receivedAt: Date.now(),
          newWidget:
            [{
                "type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
                "uid": widgetId,
                "layout": {
                  "i": widgetId,
                  "x": 0,
                  "y": 0,
                  "w": 4,
                  "h": 5
                },
                "uiState": {
                  "title": "媒體來源",
                  "controller": [],
                  "chartType": "pie",
                  "posttype": "",
                  "sentiment": "",
                  "voice": 1,
                  "contentListOpen": false,
                  "dashboard": false
                }
              }]
        };
      case '3dc8fd29-247a-4712-be07-368173262592':
        return {
          type: widgetAction.ADD,
          receivedAt: Date.now(),
          newWidget:
            [{
                "type": '3dc8fd29-247a-4712-be07-368173262592',
                "uid": widgetId,
                "layout": {
                  "i": widgetId,
                  "x": 0,
                  "y": 0,
                  "w": 4,
                  "h": 5
                },
                "uiState": {
                  "title": "個人影響力",
                  "controller": [],
                  "chartType": "bar",
                  "posttype": "",
                  "sentiment": "",
                  "voice": 1,
                  "contentListOpen": false,
                  "dashboard": false
                }
              }]
        };
    case '969a17c8-ffa9-11e9-a743-005056b1be6c':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
          [{
              "type": '969a17c8-ffa9-11e9-a743-005056b1be6c',
              "uid": widgetId,
              "layout": {
                "i": widgetId,
                "x": 0,
                "y": 0,
                "w": 4,
                "h": 5
              },
              "uiState": {
                "title": "頻道分析",
                "controller": [],
                "chartType": "bar",
                "posttype": "",
                "sentiment": "",
                "voice": 1,
                "contentListOpen": false,
                "dashboard": false
              }
            }]
      };
    case '34712cc4-39cf-4cc4-bb13-5fe93c1bd5f5':
      return {
        type: widgetAction.ADD,
        receivedAt: Date.now(),
        newWidget:
          [{
              "type": '34712cc4-39cf-4cc4-bb13-5fe93c1bd5f5',
              "uid": widgetId,
              "layout": {
                "i": widgetId,
                "x": 0,
                "y": 0,
                "w": 4,
                "h": 5
              },
              "uiState": {
                "title": "top文章分析",
                "controller": [],
                "dashboard": false
              }
            }]
      };
      case '122eca3a-2f55-46e7-868a-64cc76576f72':
        return {
          type: widgetAction.ADD,
          receivedAt: Date.now(),
          newWidget:
            [{
                "type": '122eca3a-2f55-46e7-868a-64cc76576f72',
                "uid": widgetId,
                "layout": {
                  "i": widgetId,
                  "x": 0,
                  "y": 0,
                  "w": 4,
                  "h": 5
                },
                "uiState": {
                  "title": "主題擴散路徑",
                  "controller": [],
                  "dashboard": false
                }
              }]
        };
      case '73f40b14-8b40-4a37-9693-3110c9641c91':
        return {
          type: widgetAction.ADD,
          receivedAt: Date.now(),
          newWidget:
            [{
                "type": '73f40b14-8b40-4a37-9693-3110c9641c91',
                "uid": widgetId,
                "layout": {
                  "i": widgetId,
                  "x": 0,
                  "y": 0,
                  "w": 4,
                  "h": 5
                },
                "uiState": {
                  "title": "區塊文字",
                  "chartType": "block",
                  "dashboard": false
                }
              }]
        };
      case 'fb641fd4-f4a8-11e9-a934-005056b1e7d1':
        return {
          type: widgetAction.ADD,
          receivedAt: Date.now(),
          newWidget:
            [{
                "type": 'fb641fd4-f4a8-11e9-a934-005056b1e7d1',
                "uid": widgetId,
                "layout": {
                  "i": widgetId,
                  "x": 0,
                  "y": 0,
                  "w": 4,
                  "h": 1
                },
                "uiState": {
                  "title": "橫幅文字",
                  "chartType": "block",
                  "dashboard": false
                }
              }]
        };
    default: return {
      type: widgetAction.ADD
    };
  }
}
export function get_data_by_chkey(chkey){
  let params ={ch_key : chkey}
  return myFetchWithId('',true,true)(process.env.REACT_APP_KEY_GET_DATA,params).then(json => console.log(json))
}

export function removeWidget(index, isDashboard, dBId) {
  if (isDashboard===true) {
    // delete target widget in database
    const normalFetch = myFetchWithId('', true, true);
    normalFetch(`${process.env.REACT_APP_DASHBOARD}/deletew`,{id: dBId})
      .then( data => { console.log('delete widget status', data);})

    return {
      type: widgetAction.REMOVE_DASHBOARD_WIDGET,
      removeTarget: index,
      receivedAt: Date.now()
    }
  } else {
    return {
      type: widgetAction.REMOVE_RESULT_WIDGET,
      removeTarget: index,
      receivedAt: Date.now()
    }
  }
}

export function resize(width, targetWidgetId, currentWidgets, height, isDashboard) {
  for (var i = 0; i < currentWidgets.length; i++) {
    if (currentWidgets[i].uid === targetWidgetId) {
      currentWidgets[i].layout.w = width;
      currentWidgets[i].layout.h = height;
    }
  }
  var timestamp = (new Date()).getTime();
  if (isDashboard === true) {
    return {
      type: widgetAction.RESIZE_DASHBOARD,
      newSizeTempalte: currentWidgets,
      rerenderWidgets: width,
      // During the react-grid-layout only rerender if the props.length change, so I have to made a fake and display: none widget, concat and pop it everytime
      fakewidget: {"type": 0, "uid": ("faker" + timestamp), "layout": {"i": "fake", "x":0, "y": 20, "w": 0, "h": 0}},
      receivedAt: Date.now()
    }
  } else {
    return {
      type: widgetAction.RESIZE_RESULTPAGE,
      newSizeTempalte: currentWidgets,
      rerenderWidgets: width,
      // During the react-grid-layout only rerender if the props.length change, so I have to made a fake and display: none widget, concat and pop it everytime
      fakewidget: {"type": 0, "uid": ("faker" + timestamp), "layout": {"i": "fake", "x":0, "y": 20, "w": 0, "h": 0}},
      receivedAt: Date.now()
    }
  }
}

export function resizeWithFakeWidget(width, targetWidgetId, currentWidgets, height, isDashboard) {
  for (var i = 0; i < currentWidgets.length; i++) {
    if (currentWidgets[i].uid === targetWidgetId) {
      currentWidgets[i].layout.w = width;
      currentWidgets[i].layout.h = height;
    }
  }
  if (isDashboard === true) {
    return {
      type: widgetAction.RESIZEWITHFAKER_DASHBOARD,
      newSizeTempalte: currentWidgets.slice(0, -1),
      rerenderWidgets: width,
      receivedAt: Date.now()
    }
  } else {
    return {
      type: widgetAction.RESIZEWITHFAKER_RESULTPAGE,
      newSizeTempalte: currentWidgets.slice(0, -1),
      rerenderWidgets: width,
      receivedAt: Date.now()
    }
  }
}
export function changeLayout(layout, currentWidgets, isDashboard) {
  for (var i = 0; i < currentWidgets.length; i++) {
    for (var x = 0; x < layout.length; x++) {
      if (layout[x].i === currentWidgets[i].uid) {
        currentWidgets[i].layout.w = layout[x].w;
        currentWidgets[i].layout.h = layout[x].h;
        currentWidgets[i].layout.x = layout[x].x;
        currentWidgets[i].layout.y = layout[x].y;
      };
    }
  }
  if (isDashboard === true) {
    return {
      type: widgetAction.CHANGELAYOUT_DASHBOARD,
      newLayoutTempalte: currentWidgets,
      receivedAt: Date.now()
    };
  } else {
    return {
      type: widgetAction.CHANGELAYOUT_RESULTPAGE,
      newLayoutTempalte: currentWidgets,
      receivedAt: Date.now()
    };
  }
}

export function loadDemoTemplate(type) {
  switch (type) {
    case 1:
      return {
        type: widgetAction.DEMO,
        demoTemplate: [
          {
            "type": 'f95bd230-b3c0-41fd-aaf4-4738faa75ac2',
            "uid": "widget1554257805640",
            "layout": {
              "i": "widget1554257805640",
              "x": 0,
              "y": 0,
              "w": 4,
              "h": 5
            },
            "uiState": {
              "title": "概念矩陣",
              "controller": [],
              "chartType": "treemap",
              "dashboard": false,
              "mapColor": ['#92BEEB', '#FDC59A', '#F3E9D2', 'rgb(255, 180, 175)', '#C6DABF', '#F3E9D2', '#1A936F', '#ffea96'],
              "colorForm": '預設'
            }
          },
          {
            "type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
            "uid": "010",
            "layout": {
              "i": "010",
              "x": 0,
              "y": 5,
              "w": 2,
              "h": 5
            },
            "uiState": {
              "title": "媒體來源",
              "controller": [],
              "chartType": "pie",
              "posttype": "",
              "sentiment": "",
              "voice": 1,
              "contentListOpen": false,
              "dashboard": false,
            }
          },
          {
            "type": '9f80cf4c-9467-49cf-9226-507ecee12cb6',
            "uid": "011",
            "layout": {
              "i": "011",
              "x": 2,
              "y": 5,
              "w": 2,
              "h": 5
            },
            "uiState": {
              "title": "情緒聲量",
              "controller": [],
              "chartType": "line",
              "controller": [],
              "chartType": "line",
              "posttype": "",
              "voice": 1,
              "dashboard": false,
            }
          },
          {
            "type": '355a4d6f-12a8-49e8-af27-a40b94602088',
            "uid": "012",
            "layout": {
              "i": "012",
              "x": 0,
              "y": 10,
              "w": 4,
              "h": 5
            },
            "uiState": {
              "title": "搜尋結果列表",
              "controller": [],
              "chartType": "",
              "dashboard": false,
            }
          }
        ]
      };
    case 2:
      return {
        type: widgetAction.DEMO,
        demoTemplate: [
          {
            "type": '9f80cf4c-9467-49cf-9226-507ecee12cb6',
            "layout": { "i": "widget1554258156229", "x": 2, "y": 0, "w": 2, "h": 5},
            "uid": "widget1554258156229",
            "uiState": {
              "title": "聲量分析",
              "controller": [],
              "chartType": "pie",
              "posttype": "",
              "voice": 1,
              "contentListOpen": false,
              "dashboard": false
            },
          },
          {
            "type": '9f80cf4c-9467-49cf-9226-507ecee12cb6',
            "layout": { "i": "122", "x": 0, "y": 0, "w": 2, "h": 5},
            "uid": "122",
            "uiState": {
              "title": "聲量分析",
              "controller": [],
              "chartType": "line",
              "posttype": "",
              "voice": 1,
              "contentListOpen": false,
              "dashboard": false
            },
          }
        ]
      };
      case 3:
        return {
          type: widgetAction.DEMO,
          demoTemplate: [
            {
              "type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
              "layout": { "i": "widget1554259025668", "x": 0, "y": 0, "w": 4, "h": 5},
              "uid": "widget1554259025668",
              "uiState": {
                "title": "媒體來源",
                "controller": [],
                "chartType": "pie",
                "posttype": "",
                "sentiment": "",
                "voice": 1,
                "contentListOpen": true,
                "dashboard": false
              },
            },
            {
              "type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
              "layout": { "i": "widget1554259006934", "x": 0, "y": 5, "w": 4, "h": 5},
              "uid": "widget1554259006934",
              "uiState": {
                "title": "媒體來源",
                "controller": [],
                "chartType": "bar",
                "posttype": "",
                "sentiment": "",
                "voice": 1,
                "contentListOpen": true,
                "dashboard": false
              },
            },
          ]
        };
      default: return  null;
  }
}



// WEBPACK FOOTER //
// ./src/actions/widget.actions.js